// configurator catalogue administration schemas (Worker validates, SPA reuses). lets an admin
// (permission `configurator:manage`) edit the D1-backed catalogue in-app — models, categories,
// equipment items with pricing, assembly-export labels and helm structured fields — instead of
// editing D1 + seed files by hand.
import { z } from 'zod';
import { OrderCellsSchema } from '../domain/configuratorOrder.js';
export const CATALOGUE_CATEGORY_KINDS = ['standard', 'optional', 'production'];
export const CATALOGUE_INPUT_TYPES = ['toggle', 'select', 'text', 'qty'];
export const CatalogueModelSchema = z.object({
    id: z.number().int().positive().optional(),
    code: z.string().min(1).max(40),
    name: z.string().min(1).max(120),
    year: z.number().int().min(1900).max(2100).nullable().optional(),
    active: z.boolean().optional().default(true),
});
export const CatalogueCategorySchema = z.object({
    id: z.number().int().positive().optional(),
    modelId: z.number().int().positive(),
    name: z.string().min(1).max(120),
    kind: z.enum(CATALOGUE_CATEGORY_KINDS).optional().default('standard'),
    // whether items in this category get the dealer discount. false = bespoke / transport
    // ("NOT ELIGIBLE FOR DISCOUNT" in the pricelist). defaults true.
    discountEligible: z.boolean().optional().default(true),
    displayOrder: z.number().int().optional(),
});
const price = z.number().min(0).max(100_000_000).nullable().optional();
const intN = (max) => z.number().int().min(0).max(max).nullable().optional();
export const CatalogueItemSchema = z.object({
    id: z.number().int().positive().optional(),
    modelId: z.number().int().positive(),
    categoryId: z.number().int().positive(),
    code: z.string().max(60).optional().default(''), // auto-generated from the name when empty
    name: z.string().min(1).max(400),
    description: z.string().max(2000).optional().default(''),
    isStandard: z.boolean().optional().default(false),
    defaultQuantity: z.number().int().min(0).max(9999).optional().default(1),
    inputType: z.enum(CATALOGUE_INPUT_TYPES).optional().default('toggle'),
    hasDrawing: z.boolean().optional().default(false),
    internalPrice: price,
    dealerPrice: price,
    customerPrice: price,
    active: z.boolean().optional().default(true),
    assemblyExportLabel: z.string().max(400).nullable().optional(),
    // helm / seating structured production fields
    seatingRows: intN(20),
    seatsPerRow: intN(20),
    aftConfiguration: z.string().max(120).nullable().optional(),
    fridgeQuantity: intN(99),
    fridgeCapacityLitres: intN(9999),
    compatibilityNote: z.string().max(400).nullable().optional(),
    structuredApproved: z.boolean().optional().default(false),
    // the order file rows the item ties to (null: go by the suggestion from its name and category)
    orderCells: OrderCellsSchema.nullable().optional(),
});
export const CatalogueIdSchema = z.object({ id: z.number().int().positive() });
export const CatalogueReorderSchema = z.object({
    type: z.enum(['category', 'item']),
    ids: z.array(z.number().int().positive()).max(2000),
});
//# sourceMappingURL=catalogue.js.map